import { bus, PAUSE_INTERNAL_PLAYERS } from '../eventBus';

export const pausePlayers = (gigId) => {
    bus.emit(PAUSE_INTERNAL_PLAYERS, gigId);
};
